import { GridType } from '../enums/data-grid.enum';
/**
 * Created by alex on 28-6-2017.
 */

export function GridTypeAware(constructor: Function) {
  constructor.prototype.GridType = GridType;
}
